import { render, staticRenderFns } from "./ServerCard.vue?vue&type=template&id=c06cab52&scoped=true&"
import script from "./ServerCard.vue?vue&type=script&lang=js&"
export * from "./ServerCard.vue?vue&type=script&lang=js&"
import style0 from "./ServerCard.vue?vue&type=style&index=0&id=c06cab52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06cab52",
  null
  
)

export default component.exports